import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import AsyncListTooltip from '../asyncListTooltip';
import NotificationButton from '../notificationButton';
import NotificationItem from './notificationItem';
import {
  NOTIFICATION_ITEM_BORDER,
  NOTIFICATION_ITEM_SIZE,
  NOTIFICATION_LIST_GAP,
  NOTIFICATIONS_VISIBLE_COUNT,
} from '../../../constants/globalNotifications';

const NOTIFICATION_VIRTUAL_ITEM_SIZE =
  NOTIFICATION_ITEM_SIZE + NOTIFICATION_ITEM_BORDER;

const CLEAR_ALL_BUTTON_HEIGHT = 32;

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  notificationsViewport: {
    maxHeight: `${
      NOTIFICATION_VIRTUAL_ITEM_SIZE * NOTIFICATIONS_VISIBLE_COUNT +
      NOTIFICATION_LIST_GAP * (NOTIFICATIONS_VISIBLE_COUNT - 1) +
      CLEAR_ALL_BUTTON_HEIGHT +
      spacing(3)
    }px !important`,
  },
  clearAllButton: {
    border: `1px solid ${primary.bluish1}`,
    borderRadius: 44,
    color: primary.bluish1,
    fontFamily: 'ProximaNova-Bold',
    lineHeight: '24px',
    justifySelf: 'center',
    padding: spacing(1, 2),
    maxHeight: CLEAR_ALL_BUTTON_HEIGHT,
  },
}));

const GlobalNotifications = ({
  className = undefined,
  translations,
  notificationCount = 0,
  notificationItems = [],
  canAccessNotificationCheck,
  onLoadNotifications,
  onCloseNotifications = () => {},
  onClearAllNotifications,
  onMarkAsRead,
  onViewNotification,
}) => {
  const classes = useStyles();
  const [isOpenedView, setIsOpenedView] = useState(true);

  const getVirtualNotificationItemSize = useCallback(
    () => NOTIFICATION_VIRTUAL_ITEM_SIZE,
    []
  );

  const onToggleView = value => {
    setIsOpenedView(value);

    if (value) {
      onCloseNotifications();
    }
  };

  return (
    <div className={className}>
      <AsyncListTooltip
        labelData={notificationItems}
        labelComponent={NotificationItem}
        labelComponentProps={{
          translations,
          onMarkAsRead,
        }}
        getLabelData={onLoadNotifications}
        tooltipViewportClass={classes.notificationsViewport}
        tooltipButtonLabel={translations.clearAll}
        tooltipButtonProps={{
          className: classes.clearAllButton,
          type: 'addWithTextRounded',
        }}
        emptyLabel={translations.upToDate}
        isItemClickable={canAccessNotificationCheck}
        getItemSize={getVirtualNotificationItemSize}
        shouldDisablePortal={false}
        hasTooltipButton
        onItemClickHandler={onViewNotification}
        onTooltipButtonClickHandler={onClearAllNotifications}
        onToggleView={onToggleView}
      >
        <NotificationButton
          tooltipText={
            isOpenedView ? translations.notificationButtonTooltip : ''
          }
          notificationCount={notificationCount}
        />
      </AsyncListTooltip>
    </div>
  );
};

GlobalNotifications.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.object.isRequired,
  notificationCount: PropTypes.number,
  notificationItems: PropTypes.arrayOf(PropTypes.object),
  canAccessNotificationCheck: PropTypes.func.isRequired,
  onLoadNotifications: PropTypes.func.isRequired,
  onCloseNotifications: PropTypes.func,
  onClearAllNotifications: PropTypes.func.isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
  onViewNotification: PropTypes.func.isRequired,
};

export default GlobalNotifications;
